import { getWorkflowCapabilities } from '@jira/project-settings__workflow-services-capabilities/src/getWorkflowCapabilities.tsx';
import { setMark } from '@atlassian/jira-common-performance/src/marks.tsx';
// eslint-disable-next-line jira/import-whitelist
import {
	prefetchApiReadyMark,
	prefetchApiStartMark,
} from '@atlassian/jira-providers-spa-apdex-analytics/src/marks.tsx';
import { createResourceError } from '@atlassian/jira-router-resources-utils/src/utils/create-resource-error/index.tsx';
import type { ResourceStoreContext, RouterDataContext } from '@atlassian/react-resource-router';

export const fetchWorkflowCapabilities = async (
	{ match }: RouterDataContext,
	{ tenantContext }: ResourceStoreContext,
) => {
	const { isAnonymous, cloudId } = tenantContext;

	if (isAnonymous || !match.params.workflowId) {
		const message = !match.params.workflowId
			? 'Workflow ID is not defined.'
			: "Workflows can't be edited in anonymous mode.";
		throw new Error(message);
	}

	try {
		// better way to monitor perf?
		setMark(prefetchApiStartMark);
		const workflowCapabilities = await getWorkflowCapabilities(cloudId, {
			workflowId: match.params.workflowId,
		});
		setMark(prefetchApiReadyMark);
		return workflowCapabilities;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		throw createResourceError(
			{
				component: 'spa.view.routes.admin-pages.workflows.workflow-capabilities.getData',
				message: 'An error was thrown while prefetching workflow capabilities data',
				name: 'ResourceError',
			},
			error,
		);
	}
};
